/* NIKITA scratch-off popup: replaces the Klaviyo "Claim your chain" popup.
 *
 * Flow: scratch to reveal the free chain -> details -> Gold or Silver -> chain added to cart.
 * It hands the chain to free-chain-gift.js (the same way the old Klaviyo buttons did, via /cart/add),
 * which owns the "spend 10 pounds to unlock" entitlement. Nothing here touches that rule.
 *
 * Config comes from window.NKP_CONFIG (the Liquid snippet fills it in). */
(function () {
  'use strict';
  if (window.__nkpLoaded) return;
  window.__nkpLoaded = true;

  var C = {
    companyId: 'RQRwDz',
    listId: 'UxNzh9',
    source: 'Scratch Pop Up - Free Chain',
    gifts: { gold: 55175691239800, silver: 55175691272568 },
    soldOut: [],                 // e.g. ['gold'] when a colour has run out
    heroImage: '',
    delayMs: 5000,
    snoozeDays: 1,               // after a close; matches the old Klaviyo form
    spendText: '£10',
    dryRun: false,               // true = no network calls (preview harness)
    force: false                 // true = ignore suppression (preview harness)
  };
  var user = window.NKP_CONFIG || {};
  for (var k in user) if (Object.prototype.hasOwnProperty.call(user, k)) C[k] = user[k];

  // Same wording as the Metal option on product pages
  var LABEL = { gold: 'Gold - 18k Plated', silver: 'Stainless Steel - Silver Plated' };

  /* GA4 funnel events (gtag is already on the site). Names only, no custom dimensions needed. */
  function track(name) {
    if (C.dryRun) { console.info('[nkp] event', name); return; }
    try { if (typeof window.gtag === 'function') window.gtag('event', name); } catch (e) {}
  }
  var seen = {};
  function once(name) { if (!seen[name]) { seen[name] = 1; track(name); } }


  /* ---------- email checks (client side: catches typos, junk and lazy bots, not determined ones) ---------- */
  var COMMON = ['gmail.com', 'googlemail.com', 'hotmail.com', 'hotmail.co.uk', 'outlook.com', 'outlook.co.uk', 'live.com', 'live.co.uk',
    'yahoo.com', 'yahoo.co.uk', 'icloud.com', 'me.com', 'mac.com', 'aol.com', 'msn.com', 'btinternet.com', 'sky.com',
    'virginmedia.com', 'talktalk.net', 'ntlworld.com', 'blueyonder.co.uk', 'protonmail.com', 'proton.me'];
  var DISPOSABLE = ['mailinator.com', 'guerrillamail.com', 'guerrillamail.net', 'guerrillamail.org', 'sharklasers.com', 'grr.la', '10minutemail.com',
    '10minutemail.net', 'yopmail.com', 'yopmail.fr', 'tempmail.com', 'temp-mail.org', 'temp-mail.io', 'tempmailo.com', 'trashmail.com', 'trashmail.net',
    'getnada.com', 'nada.email', 'dispostable.com', 'maildrop.cc', 'throwawaymail.com', 'fakeinbox.com', 'mailnesia.com', 'emailondeck.com',
    'mohmal.com', 'moakt.com', 'mintemail.com', 'spamgourmet.com', 'tempr.email', 'discard.email', 'burnermail.io', 'mailcatch.com', 'mytemp.email',
    'tmpmail.org', 'tmpmail.net', 'tempinbox.com', 'getairmail.com', 'fakemail.net', 'emailfake.com', 'crazymailing.com', 'inboxkitten.com',
    'mailsac.com', 'harakirimail.com', 'spambox.us', 'trbvm.com', 'tmail.ws', 'mail.tm', 'byom.de', 'dropmail.me', 'anonaddy.me'];
  var JUNK_LOCAL = ['test', 'testing', 'tester', 'asdf', 'asdfgh', 'asdfghjkl', 'qwerty', 'qwertyuiop', 'fake', 'fakeemail', 'none', 'noemail',
    'nomail', 'no', 'na', 'abc', 'abcd', 'abc123', 'xxx', 'xyz', 'name', 'email', 'example', 'user', 'null', 'nobody', 'noreply', 'donotreply'];
  var JUNK_DOMAIN = ['example.com', 'example.org', 'example.net', 'test.com', 'test.co.uk', 'domain.com', 'email.com', 'mail.test', 'invalid.com', 'noemail.com', 'none.com', 'nomail.com'];

  function lev(a, b) {
    var m = a.length, n = b.length, d = [], i, j;
    for (i = 0; i <= m; i++) d[i] = [i];
    for (j = 1; j <= n; j++) d[0][j] = j;
    for (i = 1; i <= m; i++) for (j = 1; j <= n; j++)
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    return d[m][n];
  }
  function inList(list, domain) {
    for (var i = 0; i < list.length; i++) if (domain === list[i] || domain.slice(-(list[i].length + 1)) === '.' + list[i]) return true;
    return false;
  }
  /* Returns {kind:'disposable'|'junk'} to block, {kind:'typo', fix:'a@gmail.com'} to ask, or null. */
  function checkEmail(email) {
    var at = email.lastIndexOf('@'), local = email.slice(0, at).toLowerCase(), domain = email.slice(at + 1).toLowerCase();
    if (inList(DISPOSABLE, domain)) return { kind: 'disposable' };
    if (JUNK_DOMAIN.indexOf(domain) > -1 || JUNK_LOCAL.indexOf(local) > -1 || /^(.)\1{3,}$/.test(local)) return { kind: 'junk' };
    if ((domain === 'gmail.com' || domain === 'googlemail.com') && local.replace(/\./g, '').length < 6) return { kind: 'junk' };  // Gmail needs 6+ characters
    if (COMMON.indexOf(domain) > -1) return null;
    var best = null, bestD = 3;
    for (var i = 0; i < COMMON.length; i++) {
      var dist = lev(domain, COMMON[i]);
      if (dist > 0 && dist < bestD && domain.length >= 6) { bestD = dist; best = COMMON[i]; }
    }
    return best ? { kind: 'typo', fix: email.slice(0, at) + '@' + best } : null;
  }

  var KEY = 'nkp:v1';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function write(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  function suppressed() {
    if (C.force) return false;
    var s = read();
    if (s.submitted) return true;
    return !!(s.closedAt && Date.now() - s.closedAt < C.snoozeDays * 864e5);
  }

  var revealAt = 0, typoAck = '';
  var root, tab, canvas, ctx, drawing = false, scratched = false, lastFocus = null, checkTimer = null;

  function el(html) { var d = document.createElement('div'); d.innerHTML = html.trim(); return d.firstChild; }

  function build() {
    var colours = ['gold', 'silver'].map(function (c) {
      var out = C.soldOut.indexOf(c) > -1;
      return '<button type="button" class="nkp__colour" data-c="' + c + '"' + (out ? ' disabled' : '') + '><i></i><span>' +
        LABEL[c] + (out ? ' - Sold out' : '') + '</span></button>';
    }).join('');

    root = el(
      '<div class="nkp" data-open="false" data-step="main" data-revealed="false" data-touched="false">' +
        '<div class="nkp__scrim" data-close></div>' +
        '<div class="nkp__card" role="dialog" aria-modal="true" aria-labelledby="nkp-title" tabindex="-1">' +
          '<button type="button" class="nkp__x" aria-label="Close" data-close>&times;</button>' +
          '<div class="nkp__hero"' + (C.heroImage ? ' style="background-image:url(\'' + C.heroImage + '\')"' : '') + '></div>' +
          '<div class="nkp__body">' +

            '<div data-step="main">' +
              '<p class="nkp__kicker">A gift for you</p>' +
              '<div role="heading" aria-level="2" class="nkp__title" id="nkp-title" data-title>Scratch to reveal</div>' +
              '<p class="nkp__sub" data-sub>Everyone gets one. Scratch the card to see yours.</p>' +
              '<div class="nkp__scratch">' +
                '<div class="nkp__prize"><b>FREE CHAIN</b><span>Gold or Silver &middot; worth &pound;20</span></div>' +
                '<canvas class="nkp__canvas" aria-hidden="true"></canvas>' +
                '<span class="nkp__hint" aria-hidden="true"></span>' +
              '</div>' +
              '<button type="button" class="nkp__skip" data-skip>Can&rsquo;t scratch? Tap to reveal</button>' +
              '<div class="nkp__reveal"><div>' +
                '<form class="nkp__form" novalidate>' +
                  '<div class="nkp__row">' +
                    '<input class="nkp__field" name="first" autocomplete="given-name" placeholder="First name" aria-label="First name" required>' +
                    '<input class="nkp__field" name="last" autocomplete="family-name" placeholder="Last name" aria-label="Last name" required>' +
                  '</div>' +
                  '<input class="nkp__field" name="email" type="email" autocomplete="email" placeholder="Email" aria-label="Email" required>' +
                                    '<input class="nkp__hp" name="nkp_ref" tabindex="-1" autocomplete="off" aria-hidden="true">' +
                  '<p class="nkp__err" role="alert" aria-live="polite"></p>' +
                  '<button type="submit" class="nkp__btn nkp__btn--solid">Claim your chain</button>' +
                  '<p class="nkp__fine">Free when you add ' + C.spendText + ' or more to your cart. One per order. By signing up you agree to receive marketing emails from NIKITA (new drops, offers, cart reminders). Unsubscribe any time.</p>' +
                '</form>' +
              '</div></div>' +
            '</div>' +

            '<div data-step="colour">' +
              '<p class="nkp__kicker">Free chain claimed</p>' +
              '<div role="heading" aria-level="2" class="nkp__title">Gold or silver?</div>' +
              '<p class="nkp__sub">Pick your colour and we&rsquo;ll pop it in your cart.</p>' +
              '<div class="nkp__colours">' + colours + '</div>' +
              '<p class="nkp__err" role="alert" aria-live="polite" data-colour-err></p>' +
              '<p class="nkp__fine">Free when you add ' + C.spendText + ' or more to your cart. One free chain per order.</p>' +
              '<p class="nkp__trust">WATERPROOF &nbsp;|&nbsp; HYPOALLERGENIC &nbsp;|&nbsp; TARNISH-FREE</p>' +
            '</div>' +

            '<div data-step="done">' +
              '<p class="nkp__kicker">All set</p>' +
              '<div role="heading" aria-level="2" class="nkp__title">In your cart</div>' +
              '<p class="nkp__sub">Add ' + C.spendText + ' or more and it&rsquo;s completely free.</p>' +
              '<button type="button" class="nkp__btn nkp__btn--solid" data-close>Keep shopping</button>' +
            '</div>' +

          '</div>' +
        '</div>' +
      '</div>'
    );
    tab = el('<button type="button" class="nkp-tab" aria-label="Claim your free chain"><span>Scratch &amp; claim</span><b>Your free chain</b></button>');
    document.body.appendChild(root);
    document.body.appendChild(tab);
    canvas = root.querySelector('.nkp__canvas');
    wire();
  }

  /* ---------- scratch card ---------- */
  function paintFoil() {
    var box = canvas.parentNode.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.max(1, Math.round(box.width * dpr));
    canvas.height = Math.max(1, Math.round(box.height * dpr));
    ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var w = box.width, h = box.height;
    var g = ctx.createLinearGradient(0, 0, w, h);
    g.addColorStop(0, '#8a6d1e'); g.addColorStop(.28, '#e6cc82'); g.addColorStop(.5, '#b8923a');
    g.addColorStop(.74, '#f1dd9a'); g.addColorStop(1, '#8a6d1e');
    ctx.globalCompositeOperation = 'source-over';
    ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
    for (var i = 0; i < 520; i++) {                       // fine foil grain
      ctx.fillStyle = Math.random() > .5 ? 'rgba(255,255,255,.16)' : 'rgba(80,55,10,.16)';
      ctx.fillRect(Math.random() * w, Math.random() * h, 1.4, 1.4);
    }
    ctx.fillStyle = 'rgba(60,40,5,.78)';
    ctx.font = '600 13px Poppins, "Segoe UI", system-ui, sans-serif';
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    if ('letterSpacing' in ctx) ctx.letterSpacing = '4px';
    ctx.fillText('SCRATCH HERE', w / 2, h / 2);
    ctx.globalCompositeOperation = 'destination-out';
  }

  function pos(e) { var r = canvas.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }
  var last = null;
  function stroke(p) {
    ctx.lineWidth = 38; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    ctx.beginPath(); ctx.moveTo((last || p).x, (last || p).y); ctx.lineTo(p.x, p.y); ctx.stroke();
    last = p;
  }
  function cleared() {
    var w = canvas.width, h = canvas.height, d, n = 0, t = 0, step = 6;
    try { d = ctx.getImageData(0, 0, w, h).data; } catch (e) { return 1; }
    for (var y = 0; y < h; y += step) for (var x = 0; x < w; x += step) { t++; if (d[(y * w + x) * 4 + 3] < 40) n++; }
    return n / t;
  }
  function scheduleCheck() {
    if (checkTimer) return;
    checkTimer = setTimeout(function () { checkTimer = null; if (cleared() > .42) reveal(); }, 140);
  }
  function reveal(how) {
    if (root.getAttribute('data-revealed') === 'true') return;
    track(how === 'tap' ? 'nkp_reveal_tap' : 'nkp_reveal');
    root.setAttribute('data-revealed', 'true');
    revealAt = Date.now();
    root.querySelector('[data-title]').textContent = 'It\u2019s yours';
    root.querySelector('[data-sub]').textContent = 'Add your details to claim your free chain.';
    sparkle();
    var first = root.querySelector('[name=first]');
    setTimeout(function () { if (first && root.getAttribute('data-step') === 'main') first.focus({ preventScroll: true }); }, 480);
  }
  function sparkle() {
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var host = root.querySelector('.nkp__scratch');
    for (var i = 0; i < 16; i++) {
      var s = document.createElement('span'); s.className = 'nkp__spark';
      var a = Math.random() * Math.PI * 2, r = 50 + Math.random() * 70;
      s.style.left = '50%'; s.style.top = '50%';
      s.style.setProperty('--dx', Math.cos(a) * r + 'px'); s.style.setProperty('--dy', Math.sin(a) * r * .6 + 'px');
      s.style.animationDelay = Math.random() * .12 + 's';
      host.appendChild(s); setTimeout(function (n) { return function () { n.remove(); }; }(s), 1200);
    }
  }

  /* ---------- open / close ---------- */
  function trap(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = [].filter.call(root.querySelectorAll('button, input, [href]'), function (n) { return !n.disabled && n.offsetParent !== null; });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }
  function open() {
    if (!root) build();
    once('nkp_view');
    lastFocus = document.activeElement;
    tab.setAttribute('data-show', 'false');
    root.setAttribute('data-open', 'true');
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', trap);
    requestAnimationFrame(function () {
      if (root.getAttribute('data-step') === 'main' && root.getAttribute('data-revealed') !== 'true') paintFoil();
      root.querySelector('.nkp__card').focus({ preventScroll: true });
    });
  }
  function close() {
    root.setAttribute('data-open', 'false');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', trap);
    var s = read();
    if (!s.submitted) track('nkp_close');
    if (!s.submitted) { s.closedAt = Date.now(); write(s); tab.setAttribute('data-show', 'true'); }
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }

  /* ---------- submit ---------- */
  function subscribe(d) {
    if (C.dryRun) { console.info('[nkp] DRY RUN subscribe', d); return Promise.resolve(); }
    var body = { data: { type: 'subscription', attributes: { custom_source: C.source, profile: { data: { type: 'profile', attributes: {
      email: d.email, first_name: d.first, last_name: d.last,
      properties: { '$source': C.source } } } } },
      relationships: { list: { data: { type: 'list', id: C.listId } } } } };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(C.companyId), {
      method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) return r.text().then(function (t) { console.warn('[nkp] klaviyo', r.status, t); throw new Error('klaviyo ' + r.status); }); })
      .then(function () {      // tie this browser to the profile so browse/cart flows fire
        var kl = window.klaviyo = window.klaviyo || [];
        try { kl.push(['identify', { email: d.email, first_name: d.first, last_name: d.last }]); } catch (e) {}
      });
  }
  function showSuggest(f, fix) {
    var el = f.querySelector('.nkp__suggest');
    if (!el) { el = document.createElement('div'); el.className = 'nkp__suggest'; el.setAttribute('role', 'alert'); f.querySelector('.nkp__err').after(el); }
    el.innerHTML = '<span>Did you mean <b></b>?</span><button type="button" data-fix>Yes, use it</button><button type="button" data-keep>No, keep mine</button>';
    el.querySelector('b').textContent = fix;
    el.querySelector('[data-fix]').onclick = function () { f.email.value = fix; el.remove(); track('nkp_typo_accepted'); f.requestSubmit(); };
    el.querySelector('[data-keep]').onclick = function () { typoAck = f.email.value.trim().toLowerCase(); el.remove(); track('nkp_typo_kept'); f.requestSubmit(); };
  }
  function onSubmit(e) {
    e.preventDefault();
    var f = e.target, err = f.querySelector('.nkp__err'), btn = f.querySelector('button[type=submit]');
    var d = { first: f.first.value.trim(), last: f.last.value.trim(), email: f.email.value.trim() };
    [].forEach.call(f.querySelectorAll('.nkp__field'), function (i) { i.removeAttribute('aria-invalid'); });
    var old = f.querySelector('.nkp__suggest'); if (old) old.remove();
    var bad = !d.first ? f.first : !d.last ? f.last : !/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(d.email) ? f.email : null;
    if (bad) {
      bad.setAttribute('aria-invalid', 'true'); bad.focus();
      err.textContent = bad === f.email ? 'Please enter a valid email address.' : 'Please fill in every field.';
      return;
    }
    // Bots: a hidden field a person never sees. Pretend it worked so it learns nothing; nothing is subscribed.
    if (f.nkp_ref.value) { track('nkp_block_bot'); root.setAttribute('data-step', 'colour'); return; }
    // Bots: a form submitted faster than a person could fill it. A real person who is just quick can simply try again.
    if (revealAt && Date.now() - revealAt < 1500) { track('nkp_block_fast'); err.textContent = 'Something went wrong. Please try again.'; return; }
    var chk = checkEmail(d.email);
    if (chk && chk.kind !== 'typo') {
      track('nkp_block_' + chk.kind); f.email.setAttribute('aria-invalid', 'true'); f.email.focus();
      err.textContent = chk.kind === 'disposable' ? 'Please use a personal email address you check. Temporary addresses can’t be used.' : 'That email address doesn’t look right. Please check it.';
      return;
    }
    if (chk && chk.kind === 'typo' && typoAck !== d.email.toLowerCase()) { track('nkp_typo_shown'); err.textContent = ''; showSuggest(f, chk.fix); return; }
    err.textContent = ''; btn.disabled = true; btn.textContent = 'Claiming…';
    subscribe(d).then(function () {
      var s = read(); s.submitted = true; write(s);
      track('nkp_submit');
      root.setAttribute('data-step', 'colour');
    }).catch(function () {
      btn.disabled = false; btn.textContent = 'Claim your chain';
      err.textContent = 'Something went wrong. Please try again.';
    });
  }

  /* ---------- gift ---------- */
  function addChain(colour) {
    var id = C.gifts[colour], err = root.querySelector('[data-colour-err]');
    [].forEach.call(root.querySelectorAll('.nkp__colour'), function (b) { b.disabled = true; });
    var go = C.dryRun ? Promise.resolve(console.info('[nkp] DRY RUN add to cart', colour, id)) :
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); });
    go.then(function () {
      track('nkp_colour_' + colour);
      root.setAttribute('data-step', 'done');
      // free-chain-gift.js adopts the line as an entitlement and opens the drawer
      try { if (typeof window.freeChainSync === 'function') window.freeChainSync(); } catch (e) {}
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (!C.dryRun) setTimeout(close, 900);
    }).catch(function () {
      err.textContent = 'Couldn’t add your chain. Please try again.';
      [].forEach.call(root.querySelectorAll('.nkp__colour'), function (b) { b.disabled = C.soldOut.indexOf(b.getAttribute('data-c')) > -1; });
    });
  }

  function wire() {
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-close]')) return close();
      if (t.closest('[data-skip]')) return reveal('tap');
      var c = t.closest('.nkp__colour'); if (c && !c.disabled) addChain(c.getAttribute('data-c'));
    });
    root.querySelector('form').addEventListener('submit', onSubmit);
    tab.addEventListener('click', function () { track('nkp_tab_click'); open(); });

    canvas.addEventListener('pointerdown', function (e) {
      drawing = true; last = null; scratched = true; root.setAttribute('data-touched', 'true');
      once('nkp_scratch_start'); canvas.setPointerCapture(e.pointerId); stroke(pos(e)); scheduleCheck();
    });
    canvas.addEventListener('pointermove', function (e) { if (drawing) { stroke(pos(e)); scheduleCheck(); } });
    ['pointerup', 'pointercancel'].forEach(function (n) { canvas.addEventListener(n, function () { drawing = false; last = null; scheduleCheck(); }); });
    window.addEventListener('resize', function () { if (root.getAttribute('data-open') === 'true' && root.getAttribute('data-revealed') !== 'true' && !scratched) paintFoil(); });
  }

  /* ---------- boot ---------- */
  function boot() {
    if (/^\/(cart|checkouts?)\b/.test(location.pathname)) return;
    window.nkpOpen = function () { if (!root) build(); open(); };
    if (suppressed()) {
      var s = read();
      if (!s.submitted) { build(); tab.setAttribute('data-show', 'true'); }   // snoozed: keep the corner tab
      return;
    }
    setTimeout(function () { if (!root) build(); open(); }, C.delayMs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
